import React from 'react';
import heroimg from '../icons/heroimg.svg';
const Heroimg = () => {
	return (
		<div className='hero_img'>
			<img src={heroimg} />
		</div>
	);
};

export default Heroimg;
